import { createContext, useState, PropsWithChildren, useEffect, useContext } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import themes from '../../themes/themes';

type ThemeMode = 'dark' | 'light';

type ThemeContextType = {
  themeMode: ThemeMode;
  toggleThemeMode: () => void;
};

export const ThemeContext = createContext({} as ThemeContextType);

const SAAGAS_THEME_MODE = 'saagas-theme-mode';

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const [themeMode, setThemeMode] = useState<ThemeMode>('dark');

  const toggleThemeMode = () => {
    const newMode = themeMode === 'dark' ? 'light' : 'dark';

    localStorage.setItem(SAAGAS_THEME_MODE, newMode);

    setThemeMode(newMode);
  };

  useEffect(() => {
    const localMode = localStorage.getItem(SAAGAS_THEME_MODE) as ThemeMode;

    const toggleMode = localMode === 'light' ? 'light' : 'dark';

    setThemeMode(toggleMode);
  }, []);

  return (
    <ThemeContext.Provider value={{ themeMode, toggleThemeMode }}>
      <MuiThemeProvider theme={themeMode === 'light' ? themes.light : themes.dark}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
